import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';

import { STEPS } from './flow/constants';

const RegistrationContext = createContext(null);

function RegistrationProvider({ children }) {
    const { step } = useParams();
    const isValidStep = step != null && STEPS.includes(step);
    const is404 = step != null && !STEPS.includes(step);

    const [showFlow, setShowFlow] = useState(isValidStep);
    const [currentStep, setCurrentStep] = useState(isValidStep ? step : null);

    const [showFlowLoadingOverlay, setShowFlowLoadingOverlay] = useState(false);

    const stepIndex = STEPS.indexOf(currentStep);
    const stepLength = STEPS.length;

    useEffect(() => {
        if (is404) {
            return;
        }

        if (isValidStep) {
            setCurrentStep(step);
            setShowFlow(true);
            return;
        }

        setShowFlow(false);
    }, [step, isValidStep, is404]);

    const value = useMemo(
        () => ({
            currentStep,
            is404,
            setCurrentStep,
            setShowFlowLoadingOverlay,
            setShowFlow,
            showFlow,
            showFlowLoadingOverlay,
            stepIndex,
            stepLength,
        }),
        [currentStep, is404, showFlow, showFlowLoadingOverlay, stepIndex, stepLength]
    );

    return <RegistrationContext.Provider value={value}>{children}</RegistrationContext.Provider>;
}

function useRegistrationContext() {
    const context = useContext(RegistrationContext);
    if (!context) {
        throw new Error('useRegistrationContext must be used within a RegistrationProvider');
    }
    return context;
}

export { RegistrationProvider, useRegistrationContext };
